import React from 'react';
import LeadershipChrome from '@/components/LeadershipChrome';
import { DOCTOR_MENU } from '@/config/navigationMenus';
import { LEADERSHIP_CONTENT } from '@/config/leadershipLayout';

/** Doctor workspace — same campus chrome + content width as patient portal. */
export default function DoctorCampusShell({ children, actions, flush = false }) {
  return (
    <LeadershipChrome
      homeHref="/dashboard"
      roleLabel="Doctor"
      menuItems={DOCTOR_MENU}
      actions={actions}
    >
      {flush ? children : (
        <div className={LEADERSHIP_CONTENT}>{children}</div>
      )}
    </LeadershipChrome>
  );
}
